import React from "react";
export default class IPInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {ip:{},ipType:false,uri:''};
    }

    setIP = () => {
        let ip = this.state.ip
        this.props.setIp(ip.part_1+'.'+ip.part_2+'.'+ip.part_3+'.'+ip.part_4)
    }
    IPHandler = e => {
        this.props.setError()
        let ip = this.state.ip
        const { value,name} = e.target;
        if(isNaN(value.charAt(0))){
            this.setState({ipType:false,uri:value})
            this.props.setIp(value)
        }else{
            this.setState({ipType:true})
            if(value.includes('.')){
                let _ip = value.split('.')
                _ip.map((item,key) => {
                    ip['part_'+(key+1)] = item
                })
            }else if(value <= 256 && value >=0)
            {
                ip[name] = value
            }
            this.setState({ip})
            this.setIP()
        }
    }
    render() {
        const {ip,ipType,uri} = this.state;
        return (
                <>
                    {ipType
                    ?
                        <div className="input ip-input mt-3">
                            <input type="text" value={ip.part_1} name="part_1" onChange={this.IPHandler} className="part-input" autoFocus={true}/>.
                            <input type="number" value={ip.part_2 ? ip.part_2 : ' '} name="part_2" onChange={this.IPHandler} className="part-input"/>.
                            <input type="number" value={ip.part_3 ? ip.part_3 : ' '} name="part_3" onChange={this.IPHandler} className="part-input" />.
                            <input type="number" value={ip.part_4 ? ip.part_4 : ' '} name="part_4" onChange={this.IPHandler} className="part-input"/>
                        </div>
                        :
                        <input name="part_1" onChange={this.IPHandler} value={uri} className="mt-3" type="text" autoFocus={true}/>
                    }
                </>
        );
    }
}
